<div class="percentage-wrapper d-flex align-items-center">
  @if (mayShowClearButton && hasValue && !percentageControl.disabled) {
  <button class="btn" (click)="clearValue()">
    <fa-icon [icon]="['fas', 'xmark']" size="xs"></fa-icon>
  </button>
  }
  <input
    #percentageInputControl
    class="form-control"
    type="text"
    [formControl]="percentageControl"
    inputmode="decimal"
    atxMax
    [max]="max"
    [mask]="mask"
    [dropSpecialCharacters]="false"
    [placeholder]="placeholder + ' '"
    [attr.i18n-placeholder]="i18nPlaceholder"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus()"
    (maxExceeded)="propagateMaxValueExceededEvent($event)"
  />
  <span class="input-suffix">%</span>
</div>
